import Axios from 'axios';
import { AI_API_URL } from './constants';
import { applyInterceptors } from './api';

export const aiApi = Axios.create({ baseURL: `${AI_API_URL}` });
applyInterceptors(aiApi);
